const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const hasValue = (value) => value !== null && value !== undefined;

const getVariants = (product) => (Array.isArray(product?.product_variants) ? product.product_variants : []);

export const getCatalogUnitCost = (product) => {
  if (hasValue(product?.cost_price)) {
    return toFiniteNumber(product.cost_price);
  }

  const variants = getVariants(product);
  const firstValid = variants.find((variant) => toFiniteNumber(variant?.cost_price) > 0);
  const fallback = firstValid || variants[0];
  return toFiniteNumber(fallback?.cost_price);
};

// Sin default en usdExchangeRate: con `= 0` un `undefined` del caller se volvía 0
// y el `??` no caía al usd_exchange_rate del producto (precio USD servido en ARS
// viejo). Bug P3. Si el caller no tiene tasa, pasar undefined (no 0).
export const getCatalogSalePrice = (product, usdExchangeRate) => {
  const usdRate = toFiniteNumber(usdExchangeRate ?? product?.usd_exchange_rate);
  const priceUsd = toFiniteNumber(product?.price_usd);
  // Solo aplicamos la conversión USD si el producto tiene el toggle priced_in_usd === true.
  // Esto evita que un price_usd "huérfano" en DB siga forzando la conversión a ARS
  // y bloqueando la edición del precio de venta cuando el usuario quiere trabajar en pesos.
  const pricedInUsd = product?.priced_in_usd === true;

  if (pricedInUsd && priceUsd > 0 && usdRate > 0) {
    return Number((priceUsd * usdRate).toFixed(2));
  }

  if (hasValue(product?.sell_price)) {
    return toFiniteNumber(product.sell_price);
  }

  const variants = getVariants(product);
  const firstValid = variants.find((variant) => toFiniteNumber(variant?.price) > 0);
  const fallback = firstValid || variants[0];
  return toFiniteNumber(fallback?.price);
};
